// extracted by mini-css-extract-plugin
export var emptyState = "_4z-d";
export var statCard = "_4z-c";
export var table = "_4z-0";
export var tableCell = "_4z-4";
export var tableCellClickable = "_4z-5 _4z-4";
export var tableCellDefault = "_4z-6 _4z-4";
export var tableCellEmpty = "_4z-8";
export var tableCellWithValue = "_4z-7";
export var tableContainer = "_4z-e";
export var tableHeaderWeight = "_4z-1";
export var tableHeaderZone = "_4z-2";
export var tableRowHeader = "_4z-3";
export var viewModeButton = "_4z-9";
export var viewModeButtonActive = "_4z-a _4z-9";
export var viewModeButtonInactive = "_4z-b _4z-9";